// 2026-10-06 · Errores de interfaz (excepciones JS) al registro de actividad
// del TPV, con su stack recortado, para verlos al desplegarlos en
// Actividad del TPV › Errores. El diario ya filtra por pantallas TPV y
// limita el tamaño (MAX_DATA_CHARS); aquí se evita repetir el mismo error.
// 2026-10-23 · El ruido benigno del navegador (ResizeObserver loop, Script
// error…) no es un fallo: se descarta con el mismo filtro que el handler global.

import { isIgnorableMessage } from "../globalErrorHandler";

const SAME_ERROR_MS = 10_000;
const STACK_MAX = 600;

/** Datos del evento ui.error para una excepción (sin datos sensibles). */
export function errorEventData(error, { source = "js" } = {}) {
  const message = String(error?.message || error || "Error").slice(0, 200);
  const stack = typeof error?.stack === "string"
    ? error.stack.replace(/Bearer\s+[A-Za-z0-9._-]+/g, "Bearer •••").slice(0, STACK_MAX)
    : null;
  return { message, source, ...(stack ? { stack } : {}) };
}

/** Datos del ui.error de un error de petición (axios), para el snackbar. */
export function requestErrorData(err) {
  const r = err?.response;
  if (!r && !err?.config) return null;
  const body = r?.data && typeof r.data === "object" ? r.data : {};
  return {
    status: r?.status ?? null,
    code: body.errorCode || body.code || null,
    method: err?.config?.method ? String(err.config.method).toUpperCase() : null,
    url: err?.config?.url ? String(err.config.url).split("?")[0].slice(0, 120) : null,
  };
}

/** Filtro de repetidos: el mismo mensaje en menos de 10 s no se registra. */
export function createRepeatFilter(now = () => Date.now()) {
  const last = new Map();
  return (key) => {
    const t = now();
    const prev = last.get(key);
    if (prev !== undefined && t - prev < SAME_ERROR_MS) return false;
    last.set(key, t);
    if (last.size > 50) last.delete(last.keys().next().value);
    return true;
  };
}

let installed = false;

/** Engancha window.error / unhandledrejection una sola vez. */
export function installUiErrorCapture(track) {
  if (installed || typeof window === "undefined" || typeof track !== "function") return;
  installed = true;
  const allow = createRepeatFilter();
  const report = (error) => {
    const data = errorEventData(error);
    if (isIgnorableMessage(data.message)) return;
    if (allow(data.message)) track("ui.error", data);
  };
  window.addEventListener("error", (e) => report(e?.error || e?.message));
  window.addEventListener("unhandledrejection", (e) => {
    // Las peticiones fallidas ya tienen su propio registro (api.error).
    if (e?.reason?.isAxiosError || e?.reason?.response) return;
    report(e?.reason);
  });
}
